import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const OtherIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.33329 2L14 6.66667M9.33329 6.66667L14 2M1.99996 4.33333C1.99996 4.63975 2.06031 4.94317 2.17757 5.22626C2.29483 5.50935 2.46671 5.76658 2.68338 5.98325C2.90005 6.19992 3.15727 6.37179 3.44036 6.48905C3.72346 6.60631 4.02688 6.66667 4.33329 6.66667C4.63971 6.66667 4.94313 6.60631 5.22622 6.48905C5.50931 6.37179 5.76654 6.19992 5.98321 5.98325C6.19988 5.76658 6.37175 5.50935 6.48901 5.22626C6.60627 4.94317 6.66663 4.63975 6.66663 4.33333C6.66663 4.02692 6.60627 3.7235 6.48901 3.44041C6.37175 3.15731 6.19988 2.90009 5.98321 2.68342C5.76654 2.46675 5.50931 2.29488 5.22622 2.17761C4.94313 2.06035 4.63971 2 4.33329 2C4.02688 2 3.72346 2.06035 3.44036 2.17761C3.15727 2.29488 2.90005 2.46675 2.68338 2.68342C2.46671 2.90009 2.29483 3.15731 2.17757 3.44041C2.06031 3.7235 1.99996 4.02692 1.99996 4.33333ZM1.66663 14H6.99996L4.33329 9.33333L1.66663 14ZM9.33329 9.33333H14V14H9.33329V9.33333Z"
          stroke="#5D708C"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
